import { defineMessages } from 'react-intl';

export const reportMessages = defineMessages({
  reportedContent: {
    defaultMessage: 'Content reported on {reportedAt}',
    id: '/OP4Sg',
  },
});
